/*
 * TrackerBase Admin Subscription Management Module
 * Angular Module: "trackerbase-app.views.trackerbase-admin.tb-subscription-management"
 * Route: /admin/subscriptions
 */

import angular from "angular";

import TbSubscriptionManagementController from "./TbSubscriptionManagementController";
import TbSubscriptionManagementConfiguration from "./TbSubscriptionManagementConfiguration";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

const tbSubscriptionManagementModuleDependencies = DependencyListBuilder([
    TbSubscriptionManagementController.dependencies,
    TbSubscriptionManagementConfiguration.dependencies
]);

export default angular
    .module("trackerbase-app.views.trackerbase-admin.tb-subscription-management",
        tbSubscriptionManagementModuleDependencies
    )
    .config(TbSubscriptionManagementConfiguration)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/TbSubscriptionManagement.js
// module id = m+/c
// module chunks = 1